/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Status_No_Content_HintInputs */



/**
* | output |
* | --- |
* | "The file was read successfully but contains no text. A page that builds its content with JavaScript has nothing readable in the file itself." |
*
* @param {Spaces_Status_No_Content_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_status_no_content_hint = /** @type {((inputs?: Spaces_Status_No_Content_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Status_No_Content_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Datei wurde gelesen, enthält aber keinen Text. Eine Seite, die ihre Inhalte per JavaScript aufbaut, hat in der Datei selbst nichts Lesbares.")
	return /** @type {LocalizedString} */ ("The file was read successfully but contains no text. A page that builds its content with JavaScript has nothing readable in the file itself.")
});